import moment from 'moment'
import React from 'react'
import Linkify from 'react-linkify'

import Text from 'components/common/Text'

import { Wrapper } from './styles'

const ComponentDecorator = (decoratedHref, decoratedText, key) => (
    <a target="blank" href={decoratedHref} key={key}>
        {decoratedText}
    </a>
)

const Message = ({ message, timestamp, ...rest }) => (
    <Wrapper {...rest}>
        <Linkify componentDecorator={ComponentDecorator}>
            <Text level="3" color="#000008cc" bold={false} className="message">
                {message}
                <Text color="#000008cc" className="timestamp">
                    {moment(timestamp).format('hh:mm a')}
                </Text>
            </Text>
        </Linkify>
    </Wrapper>
)

export default Message
